import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import api from "@/lib/api";
import { ArrowLeft, Users, Route, Gauge, Calendar, MapPin, Sparkles } from "lucide-react";

export default function AircraftDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/fleet/${id}`).then(r => setA(r.data)).catch(() => nav("/charter")); }, [id, nav]);

  if (!a) return <div className="min-h-screen bg-[#FAF7F0]"><PublicNav /></div>;

  return (
    <div className="min-h-screen bg-[#FAF7F0] text-[#1A1D24]">
      <PublicNav />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">
        <Link to="/charter" className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] hover:text-[#1A1D24] flex items-center gap-2" data-testid="back-to-charter"><ArrowLeft size={13}/> Back to fleet</Link>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7 relative">
            <img src={a.image_url} alt={a.model} className="w-full aspect-[4/3] object-cover as-card"/>
            <div className="absolute top-5 left-5 as-pill as-pill-gold">{a.category}</div>
          </div>
          <div className="md:col-span-5">
            <div className="as-overline">{a.manufacturer} · {a.year}</div>
            <h1 className="as-serif text-5xl md:text-6xl font-light mt-3 leading-[1]" data-testid="aircraft-title">{a.model}</h1>
            <div className="as-mono text-xs text-[#756E64] mt-2">Registration · {a.tail_number}</div>
            <div className="mt-8 grid grid-cols-2 gap-5">
              <Stat icon={Users} label="Passengers" value={a.max_passengers}/>
              <Stat icon={Route} label="Range" value={`${a.range_nm.toLocaleString()} nm`}/>
              <Stat icon={Gauge} label="Cruise Speed" value={`${a.cruise_speed_kts} kts`}/>
              <Stat icon={MapPin} label="Home Base" value={a.base}/>
            </div>
            <div className="mt-8 as-card p-6">
              <div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64]">Estimated Hourly</div>
              <div className="as-serif text-4xl text-[#A47E2A] mt-1">${a.hourly_rate_usd.toLocaleString()}</div>
              <div className="text-xs text-[#756E64] mt-2">Final quote depends on route, positioning, permits, and dwell time.</div>
              <Link to={`/charter/inquiry?aircraft=${a.id}`} className="as-btn-gold w-full block text-center px-4 py-4 rounded-sm as-mono text-xs uppercase tracking-[0.2em] mt-6" data-testid="aircraft-request-quote">
                Request Quote for this Aircraft
              </Link>
            </div>
            <div className="mt-6">
              <div className="as-overline mb-3">Interior features</div>
              <ul className="space-y-2">
                {a.features?.map((f, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-[#1A1D24]">
                    <Sparkles size={12} className="as-gold"/> {f}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value }) {
  return (
    <div>
      <Icon size={16} className="text-[#756E64] mb-2"/>
      <div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64]">{label}</div>
      <div className="as-serif text-2xl mt-1">{value}</div>
    </div>
  );
}
